
export enum OrderDomain {
  inTime = 'inTime',
  Temsera = 'Temsera',
}

